import { motion } from 'framer-motion';

const partners = [
    'Ville de Durbuy',
    'Province de Luxembourg',
    'Fédération Wallonie-Bruxelles',
    'Centre Culturel de Durbuy',
    'Syndicat d’Initiative de Barvaux',
    'Maison du Tourisme',
    'Bibliothèque de Barvaux',
    'AFUTAB',
    // Duplicate for seamless loop
    'Ville de Durbuy',
    'Province de Luxembourg',
    'Fédération Wallonie-Bruxelles',
    'Centre Culturel de Durbuy',
    'Syndicat d’Initiative de Barvaux',
    'Maison du Tourisme',
    'Bibliothèque de Barvaux',
    'AFUTAB',
];

export default function PartnersBar() {
    return (
        <section className="py-12 bg-white border-t border-gray-100 overflow-hidden">
            <div className="container mx-auto px-6 mb-8 text-center">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest">Nos Partenaires</h3>
            </div>

            <div className="flex overflow-hidden relative">
                <motion.div
                    animate={{ x: ['0%', '-50%'] }}
                    transition={{ duration: 30, ease: 'linear', repeat: Infinity }}
                    className="flex whitespace-nowrap gap-16 px-8"
                >
                    {partners.map((partner, index) => (
                        <div key={index} className="text-xl md:text-2xl font-serif text-gray-300 font-bold">
                            {partner}
                        </div>
                    ))}
                </motion.div>

                {/* Gradients to fade edges */}
                <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
                <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
            </div>
        </section>
    );
}
